import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-export-notes-dialog',
  templateUrl: './confirm-export-notes-dialog.component.html',
  styleUrls: ['./confirm-export-notes-dialog.component.scss'],
})
export class ConfirmExportNotesDialogComponent implements OnInit {
  conflictingPlayers: any[];
  conflictingGameNotes: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: string,
    private dialogRef: MatDialogRef<ConfirmExportNotesDialogComponent>
  ) {
    this.conflictingPlayers = this.data["conflictingPlayers"];
    this.conflictingGameNotes = this.data["conflictingGameNotes"];
  }

  ngOnInit() {}

  close(choice: string) {
    this.dialogRef.close({choice});
  }

}
